const { fetch: originalFetch } = window;

export const fetchWithAuth = async (...args: [RequestInfo, RequestInit?]) => {
  try {
    const response = await originalFetch(...args);

    handleUnauthorizedStatus(response.status)

    return response;
  } catch (error) {
    console.error("Fetch error:", error);

    throw error;
  }
};

const handleUnauthorizedStatus = (status: number) => {
    const UNAUTHORIZED = 401;
    const FORBIDDEN = 403;

    if ([UNAUTHORIZED, FORBIDDEN].includes(status)) {
      window.location.href = "/auth/login";
    }
};
